var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.currentFormShow && _vm.isnNullRender
    ? _c(
        "render-form-item",
        {
          attrs: {
            labelText: _vm.labelName,
            labelPosition: _vm.labelPosition,
            lineHeight: _vm.lineHeight,
            strong: _vm.strong,
            italic: _vm.italic,
            indent: _vm.indent,
            wrap: _vm.wrap,
            whereColor: _vm.whereColor,
            renderColor: _vm.renderColor
          }
        },
        [
          _c("render-form-content", {
            attrs: {
              underline: _vm.isUnderline,
              italic: _vm.italic == "value",
              strong: _vm.strong == "value",
              content: _vm.renderCurrentModel,
              leftFilling: _vm.leftUnderlineLength,
              rightFilling: _vm.rightUnderlineLength,
              whereColor: _vm.whereColor,
              renderColor: _vm.renderColor
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14649af0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14649af0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/render_item/RenderArray.vue
// module id = null
// module chunks = 